(() => {
  function init(root = document) {
    root.querySelectorAll('[data-product-studio]').forEach(section => {
      if (section.dataset.galleryReady) return;
      section.dataset.galleryReady = 'true';
      const slides = [...section.querySelectorAll('[data-media-id]')];
      const thumbs = [...section.querySelectorAll('[data-media-target]')];
      let index = Math.max(0, slides.findIndex(slide => !slide.hidden));
      function show(next) {
        if (!slides.length) return;
        index = (next + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          if (i !== index && !slide.hidden) {
            slide.querySelectorAll('video').forEach(video => video.pause());
            slide.querySelectorAll('iframe').forEach(frame => { const src = frame.getAttribute('src'); if (src) frame.setAttribute('src', src); });
            slide.querySelectorAll('model-viewer').forEach(model => model.pause?.());
          }
          slide.hidden = i !== index;
        });
        thumbs.forEach(thumb => thumb.setAttribute('aria-pressed', String(thumb.dataset.mediaTarget === slides[index].dataset.mediaId)));
        const count = section.querySelector('[data-gallery-count]');
        if (count) count.textContent = `${String(index + 1).padStart(2, '0')} / ${String(slides.length).padStart(2, '0')}`;
      }
      thumbs.forEach(thumb => thumb.addEventListener('click', () => show(slides.findIndex(slide => slide.dataset.mediaId === thumb.dataset.mediaTarget))));
      section.querySelector('[data-gallery-prev]')?.addEventListener('click', () => show(index - 1));
      section.querySelector('[data-gallery-next]')?.addEventListener('click', () => show(index + 1));
      section.querySelector('.studio-thumbnails')?.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        show(event.key === 'Home' ? 0 : event.key === 'End' ? slides.length - 1 : index + (event.key === 'ArrowRight' ? 1 : -1));
        thumbs[index]?.focus();
      });
      const dialog = section.querySelector('[data-lightbox]');
      section.querySelectorAll('[data-image-zoom]').forEach(button => button.addEventListener('click', () => {
        const img = dialog.querySelector('[data-lightbox-image]');
        img.src = button.dataset.src;
        img.alt = button.dataset.alt;
        dialog.showModal();
      }));
      section.querySelector('[data-lightbox-close]')?.addEventListener('click', () => dialog.close());
      dialog?.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      const select = section.querySelector('[data-variant-select]');
      select?.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        const available = option.dataset.available === 'true';
        section.querySelector('[data-product-price]').textContent = option.dataset.price;
        const compare = section.querySelector('[data-product-compare]');
        compare.textContent = option.dataset.compare || '';
        compare.hidden = !option.dataset.compare;
        const button = section.querySelector('[data-add-button]');
        button.disabled = !available;
        button.textContent = available ? 'In den Warenkorb ↗' : 'Ausverkauft';
        section.querySelector('[data-product-availability]').textContent = available ? 'Bestellbar' : 'Ausverkauft';
        const sku = section.querySelector('[data-product-sku]');
        sku.hidden = !option.dataset.sku;
        sku.textContent = `Artikel-Nr. ${option.dataset.sku || ''}`;
        const quantity = section.querySelector('[name="quantity"]');
        quantity.min = option.dataset.min || '1'; quantity.step = option.dataset.step || '1';
        if (option.dataset.max) quantity.max = option.dataset.max; else quantity.removeAttribute('max');
        quantity.value = quantity.min;
        if (option.dataset.media) {
          const mediaIndex = slides.findIndex(slide => slide.dataset.mediaId === option.dataset.media);
          if (mediaIndex >= 0) show(mediaIndex);
        }
        const url = new URL(location.href); url.searchParams.set('variant', select.value);
        history.replaceState({}, '', url);
      });
      show(index);
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
